export default __webpack_public_path__ + "static/media/Peru-GBC-Gris.dc934718.jpg";